const routes = {
  register: '/register',
  login: '/login',
  dashboard: '/',
  home: '/home',
  diagram: '/diagram',
  currency: '/currency',
};

export default routes;
